import LegalPageWrapper from '@/routes/legal+/LegalPageWrapper';

const TermsOfServicePage = () => {
  return (
    <LegalPageWrapper title="Terms of Service">
      <div>
        <div className="space-y-6">
          <h1 className="text-2xl font-bold leading-tight">
            Please read these Terms of Service (“Terms”) carefully before using
            Our Application and/or Services.
          </h1>

          <h2 className="text-lg font-bold my-4">
            INTERPRETATION AND DEFINITIONS
          </h2>

          <h3 className="text-xl font-semibold">Interpretation</h3>
          <p className="text-base">
            The words of which the initial letter is capitalized have meanings
            defined under the following conditions. The following definitions
            shall have the same meaning regardless of whether they appear in
            singular or in plural.
          </p>

          <h3 className="text-xl font-semibold">Definitions</h3>
          <p className="text-base">For the purposes of these Terms:</p>
          <ul className="ml-6 list-disc space-y-2">
            <li>
              <strong>Application</strong> means the “gener.us” Application
              provided by the Company and downloaded by an External User on any
              electronic Device.
            </li>
            <li>
              <strong>Application Store</strong> means the digital distribution
              service operated and developed for the Application to be
              downloaded.
            </li>
            <li>
              <strong>Affiliate</strong> means an entity that controls, is
              controlled by or is under common control with a party, where
              &quot;control&quot; means ownership of 50% or more of the shares,
              equity interest or other securities entitled to vote for election
              of directors or other managing authority.
            </li>
            <li>
              <strong>Country</strong> refers to the United States of America.
            </li>
            <li>
              <strong>Future City Now</strong> (referred to as either &quot;the
              Company&quot;, &quot;We&quot;, &quot;Us&quot; or &quot;Our&quot;
              in this Agreement) refers to Future City Now, located at 4827 Old
              National Hwy PMB 10025, Atlanta, GA 30337.
            </li>
            <li>
              <strong>Device</strong> means any electronic mechanism that can
              access our Application and/or Services such as a computer, a
              cellphone or a digital tablet.
            </li>
            <li>
              <strong>External User</strong> (referred to as either “an External
              User”, “You”, or “Your”) include all visitors, guests, who access
              the Company’s public Website or use the Company’s Application or
              any other online service, provided by the Company.
            </li>
            <li>
              <strong>Support</strong> refers to assistance provided to
              troubleshoot technical issues related to the Application provided
              by the Company for use by an External User.
            </li>
            <li>
              <strong>Terms of Service</strong> (also referred as
              &quot;Terms&quot;) mean these Terms that form the entire agreement
              between You and the Company regarding the use of the Company’s
              Application and/or Services.
            </li>
            <li>
              <strong>Third-Party Service Provider</strong> means any services
              or content (including data, information, products, or services)
              provided by a Third-Party that may be displayed, included, or made
              available by the Company’s Application and/or Services.
            </li>
          </ul>

          <h2 className="text-lg font-bold my-4">ACKNOWLEDGEMENT</h2>
          <p className="text-base">
            These are the Terms governing the use of this Application and/or
            Services and the agreement that operates between You and the
            Company. These Terms set out the rights and obligations of all
            External Users regarding the use of the Application and/or Services.
          </p>
          <p className="text-base">
            Your access to Application and use of Services is conditioned on
            Your acceptance of and compliance with these Terms. These Terms
            apply to all External Users who access or use the Application and/or
            Services.
          </p>
          <p className="text-base">
            By accessing or using the Application and/or Services You agree to
            be bound by these Terms. If You disagree with any part of these
            Terms, access to the Application and/or Services will not be
            granted.
          </p>
          <p className="text-base">
            You are responsible for Your own account and the content that You
            create, share or access through gener.us. You must not use gener.us
            for any illegal, fraudulent, harmful, or offensive purposes, or to
            infringe the rights of others.
          </p>
          <p className="text-base">
            We do not store Your credit card information. We use a Third-Party
            Service Provider to process Your transactions. You are responsible
            for providing accurate and complete payment information and
            complying with Third-Party Service Provider’s Terms of Service and
            Privacy Policies.
          </p>
          <p className="text-base">
            You represent that You are over the age of 18. The Company does not
            permit those under 18 to use its Application and/or Services.
          </p>
          <p className="text-base">
            Your access to the Application and use of the Services is also
            conditioned on Your acceptance of and compliance with the Privacy
            Policy of the Company and any other policies that We may publish on
            Our Website or Application. Our Privacy Policy describes Our
            policies and procedures for the collection, use and disclosure of
            Your personal information when You use the Application or the
            Website, and tells You about Your privacy rights and how the law
            protects You. Please carefully read our Privacy Policy, located at
            <a
              href="/legal/privacy-policy"
              className="underline decoration-[#7F7F79] underline-offset-4 ml-1"
            >
              here
            </a>
            , before using Our Application and/or Services.
          </p>
          <p className="text-base">
            By clicking the “I AGREE” checkbox below, You acknowledge Your
            agreement to be bound by these Terms. In return, You will receive
            authorized access to the Company’s Application and/or Services in
            accordance with these Terms.
          </p>
        </div>

        <div className="space-y-6">
          <h2 className="text-lg font-bold my-4">LINKS TO OTHER WEBSITES</h2>
          <p className="text-base">
            Our Application and/or Services may contain links to third-party
            websites or Services that are not owned or controlled by the
            Company.
          </p>
          <p className="text-base">
            The Company has no control over, and assumes no responsibility for,
            the content, Privacy Policies, or practices of any Third-Party
            Service Provider’s Websites or Services. You further acknowledge and
            agree that the Company shall not be responsible or liable, directly,
            or indirectly, for any damage or loss caused or alleged to be caused
            by or in connection with the use of or reliance on any such content,
            goods or services available on or through any such Websites or
            Services.
          </p>
          <p className="text-base">
            We strongly encourage You to read the Terms of Service and Privacy
            Policies of any Third-Party Service Provider’s Websites or Services
            that You visit.
          </p>

          <h2 className="text-lg font-bold my-4">TERMINATION</h2>
          <p className="text-base">
            We may modify, suspend, or terminate Your access at any time,
            without prior notice or liability, for any reason whatsoever,
            including without limitation if You breach these Terms.
          </p>
          <p className="text-base">
            Upon termination, Your right to use the Application and/or Services
            will cease immediately.
          </p>

          <h2 className="text-lg font-bold my-4">INDEMNIFICATION</h2>
          <p className="text-base">
            You agree to indemnify and hold harmless the Company, and any of Our
            Affiliates, successors, assigns, or licensees, together with any of
            their respective board members, partners, officers, directors, and
            employees against any damages, losses, liabilities, judgements,
            costs and expenses (including reasonable attorneys’ fees and costs)
            arising out of a claim by the Company or any third party related to
            Your use of Application and/or Systems, and for any claim based on
            Your alleged or actual breach or violation of these Terms.
          </p>

          <h2 className="text-lg font-bold my-4">LIMITATION OF LIABILITY</h2>
          <p className="text-base">
            To provide you with access to our application and/or services, we
            are unable to accept liability for any conduct, acts or omissions
            occurring because of your use of such application and/or services.
            Therefore, to the maximum extent permitted by law, in no event will
            the company or its employees and agents be liable for any direct,
            indirect, incidental, special, or consequential damages, losses, or
            expenses (including, without limitation, lost profits, or damages
            arising from lost data or business interruption) arising out of or
            in any way connected with external users’ use of our application
            and/or services, whether or not the company has been advised of the
            possibility of such damages or from any communications, interactions
            or meetings with external users, on any theory of liability
            (including contract, tort including negligence, or howsoever
            otherwise) arising out of, in connection with, or resulting from our
            application and/or services.
          </p>

          <h2 className="text-lg font-bold my-4">
            “AS IS” AND “AS AVAILABLE” DISCLAIMER
          </h2>
          <p className="text-base">
            The Application and/or Services are provided to You &quot;AS
            IS&quot; and &quot;AS AVAILABLE&quot; and with all faults and
            defects without warranty of any kind. To the maximum extent
            permitted under applicable law, the Company, on its own behalf and
            on behalf of its Affiliates and their respective licensors and
            service providers, expressly disclaims all warranties, whether
            express, implied, statutory or otherwise, with respect to the
            Application and/or Services, including all implied warranties of
            merchantability, fitness for a particular purpose, title and
            non-infringement, and warranties that may arise out of the course of
            dealing, course of performance, usage or trade practice. Without
            limitation to the foregoing, the Company provides no warranty or
            undertaking, and makes no representation of any kind that the
            Application and/or Services will meet Your requirements, achieve any
            intended results, be compatible or work with any other software,
            Application, systems or Services, operate without interruption, meet
            any performance or reliability standards or be error free or that
            any errors or defects can or will be corrected.
          </p>
          <p className="text-base">
            Without limiting the foregoing, neither the Company nor any of the
            Company&apos;s providers makes any representation or warranty of any
            kind, express or implied: (i) as to the operation or availability of
            the Application and/or Services, or the information, content, and
            materials or products included thereon; (ii) that the Application
            and/or Services will be uninterrupted or error-free; (iii) as to the
            accuracy, reliability, or currency of any information or content
            provided through the Application and/or Services; or (iv) that the
            Application and/or Services, its servers, the content, or e-mails
            sent from or on behalf of the Company are free of viruses, scripts,
            trojan horses, worms, malware, timebombs or other harmful
            components.
          </p>
          <p className="text-base">
            Some jurisdictions do not allow the exclusion of certain types of
            warranties or limitations on applicable statutory rights of a
            consumer, so some or all of the above exclusions and limitations may
            not apply to You. But in such a case the exclusions and limitations
            set forth in this section shall be applied to the greatest extent
            enforceable under applicable law.
          </p>
        </div>

        <div className="space-y-6">
          <h2 className="text-lg font-bold my-4">GOVERNING LAW</h2>
          <p className="text-base">
            You agree that You will not make public or announce these Terms or
            Your relationship or dealings with the Company. Further, You will
            not use the Company’s name, Trademarks, logos, or the names of
            current or former employees except upon the prior written consent of
            the Company, or its designee, in concurrence with the Company’s
            Partners.
          </p>

          <h2 className="text-lg font-bold my-4">DISPUTE RESOLUTION</h2>
          <p className="text-base">
            You hereby agree that these Terms and Your use of Our Application
            and/or Services shall be governed in all respects by the internal
            substantive laws of the State of Georgia, without regard to its
            conflicts of law’s provisions. You hereby submit to exclusive
            jurisdiction and venue in the state and federal courts located in
            Georgia for all disputes, cases and controversies regarding Our
            Application and/or Services, Your use of Our Application and/or
            Services, and Your relationship with the Company.
          </p>
          <p className="text-base">
            YOU AND THE COMPANY AGREE THAT ANY CAUSE OF ACTION ARISING OUT OF OR
            RELATED TO THESE TERMS OR YOUR USE OF THE SITE MUST COMMENCE WITHIN
            ONE (1) YEAR AFTER THE CAUSE OF ACTION ACCRUES. OTHERWISE, SUCH
            CAUSE OF ACTION IS PERMANENTLY BARRED.
          </p>
          <p className="text-base">
            If You have any concerns or disputes about the Application and/or
            Services, You agree to first try to resolve the dispute informally
            by contacting the Company via email:
            <a
              href="mailto:incidents@futurecitynow.com"
              className="underline decoration-[#7F7F79] underline-offset-4 ml-1"
            >
              incidents@futurecitynow.com
            </a>
            .
          </p>

          <h2 className="text-lg font-bold my-4">
            NOTICE TO USERS IN THE EUROPEAN UNION
          </h2>
          <p className="text-base">
            Currently, our operations and customers are located primarily in the
            United States. These Terms do not apply to users who are in the
            European Union (EU) or the European Economic Area (EEA), as they are
            subject to different data protection laws and regulations. If you
            are an EU or EEA user, please do not use the gener.us Application
            and/or Services or provide any personal information to us.
          </p>

          <h2 className="text-lg font-bold my-4">
            UNITED STATES LEGAL COMPLIANCE
          </h2>
          <p className="text-base">
            You represent and warrant that (i) You are not located in a country
            that is subject to the United States government embargo, or that has
            been designated by the United States government as a &quot;terrorist
            supporting&quot; country, and (ii) You are not listed on any United
            States government list of prohibited or restricted parties.
          </p>

          <h2 className="text-lg font-bold my-4">SEVERABILITY AND WAIVER</h2>
          <p className="text-base">
            Except as provided herein, the failure to exercise a right or to
            require performance of an obligation under these Terms shall not
            affect a party&apos;s ability to exercise such right or require such
            performance at any time thereafter nor shall the waiver of a breach
            constitute a waiver of any subsequent breach.
          </p>

          <h2 className="text-lg font-bold my-4">TRANSLATION INTERPRETATION</h2>
          <p className="text-base">
            These Terms may have been translated if We have made them available
            to You while using the Application and/or Services. You agree that
            the original English text shall prevail in the case of a dispute.
          </p>

          <h2 className="text-lg font-bold my-4">CHANGES TO THESE TERMS</h2>
          <p className="text-base">
            We reserve the right, at Our sole discretion, to modify or replace
            these Terms at any time. If a revision is material, We will make
            reasonable efforts to provide at least 30 days&apos; notice prior to
            any new terms taking effect. What constitutes a material change will
            be determined at Our sole discretion.
          </p>
          <p className="text-base">
            By continuing to use the Application and/or Services after those
            revisions become effective, You agree to be bound by the revised
            terms. If You do not agree to the new terms, in whole or in part,
            please stop using the Application and/or Services.
          </p>
        </div>

        <div className="space-y-6">
          <h2 className="text-lg font-bold my-4">CONTACT US</h2>
          <p className="text-base">
            If You have any questions about these Terms, You can contact Us by
            email:
            <a
              href="mailto:incidents@futurecitynow.com"
              className="underline decoration-[#7F7F79] underline-offset-4 ml-1"
            >
              incidents@futurecitynow.com
            </a>
            .
          </p>
          <p className="text-base">
            You agree to and accept these Terms and the Company’s Privacy Policy
            and agree to comply with all applicable laws regarding the use,
            access, or disclosure of data accessed while using Your Application
            and/or Services.
          </p>
        </div>
      </div>
    </LegalPageWrapper>
  );
};

export default TermsOfServicePage;
